<template>
  <!-- 薪酬发放（Ok保专属页） -->
  <div class="content main-container">
    <div class="tools-box right">
      <Button type="primary" @click="exportTableData">导出明细</Button>
      <Button type="primary" ghost @click="back($route.query.backUrl)">返回</Button>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table
        :columns="columns"
        :data="tableData"
        row-key="key"
        ref="selection"
      >
        <!-- 业务员姓名 -->
        <template slot-scope="{ row }" slot="userName">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }"></i>
              <span class="user-name">{{ row.staffNo }}</span>
              <span v-if="row.staffNo">/</span>
              <span class="user-name">{{ row.userName }}</span>
            </div>
          </div>
        </template>
        <!-- 状态 -->
        <template slot-scope="{ row }" slot="status">
          <div class="tag">
            <span v-if="row.okbStatus == '-2'" class="item not-started">待发放</span>
            <span v-else-if="row.okbStatus == '0'" class="item processing">待提现</span>
            <span v-else-if="row.okbStatus == '9'" class="item processing">银行处理中</span>
            <span v-else-if="row.okbStatus == '3'" class="item processing">待审核</span>
            <span v-else-if="row.okbStatus == '1'" class="item success">提现成功</span>
            <span v-else-if="[-1, 2].includes(row.okbStatus * 1)" class="item ended">提现失败</span>
            <span v-else-if="row.okbStatus == '99'" class="item ended">已冻结</span>
          </div>
        </template>
        <!-- 证件号 -->
        <template slot-scope="{ row }" slot="idNo">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
            <sensitiveView :data="row" queryKey="userId" keyName="idNo" dataType="1" fun="50" />
          </div>
        </template>
        <template slot-scope="{ row }" slot="alipayAccount">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-if="row.cardNo">
            <sensitiveView :data="row" queryKey="userId" keyName="alipayAccount" dataType="9" fun="50" />
          </div>
        </template>
        <!-- 银行卡号 -->
        <template slot-scope="{ row }" slot="cardNo">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-if="row.cardNo">
            <sensitiveView :data="row" queryKey="userId" keyName="cardNo" dataType="3" fun="50" />
          </div>
        </template>
        <!-- 手机号 -->
        <template slot-scope="{ row }" slot="mobile">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-if="row.mobile">
            <sensitiveView :data="row" queryKey="userId" keyName="mobile" dataType="8" fun="50" />
          </div>
        </template>
        <!-- 保单状态 -->
        <template slot-scope="{ row }" slot="policyStatus">
          <lzDicTxt dicType="POLICY_STATUS" :dicCode="row.policyStatus"></lzDicTxt>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
    </div>
  </div>
</template>

<script>
import lzDicTxt from '@/components/commons/lzDicTxt';
import confirmModal from '@/components/commons/confirmModal';
import withdrawalList from './components/withdrawalList';
import detailModal from '@/pages/financialManage/salesmanWithdrawalOK/components/detailModal';
import batchModal from './components/batchModal';
import okbaoCheck from './components/okbaoCheck';
import freezeAddModal from '@/pages/financialManage/salesmanWithdrawalOK/components/freezeAddModal';
import freezeRemoveModal from '@/pages/financialManage/salesmanWithdrawalOK/components/freezeRemoveModal';
import sensitiveView from '@/components/commons/sensitiveView';
import { pageTool, common } from '@/api/mixins';
import { config } from './index.config.js';

export default {
  mixins: [config, pageTool, common],
  components: {
    lzDicTxt,
    withdrawalList,
    freezeAddModal,
    freezeRemoveModal,
    sensitiveView,
    batchModal,
    okbaoCheck,
    detailModal,
    confirmModal
  },
  props: {},
  data() {
    return {
      loading: false,
      tabId: '2',
      hideAction: true,
      searchParams: {}
    };
  },
  watch: {},
  computed: {},
  created() {
    this.initListParams('/buz/userCashWithdrawLog/queryRiskPolicyPage');
  },
  activated() {
    this.initList();
  },
  methods: {
    initList() {
      this.getList();
    },
    // 转化参数
    setListParams(params) {
      params.isAll = 1;
      params.idList = this.$route.query.riskPolicyIds.split(',');
    },
    // 导出
    exportTableData() {
      if (!this.$units.pointAction('offline_81_7_btn4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/userCashWithdrawLog/exportRiskPolicyPage', params, 'POST');
    },
  }
};
</script>
<style lang="scss" scoped>
.info {
  margin-bottom: 15px;
  color: #727c8e;
  line-height: 1.8;
  overflow: hidden;
  position: relative;
}
.table-box {
  /deep/ .ivu-poptip {
    margin-left: 0 !important;
  }
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
/deep/ .tag {
  width: 100%;
  display: flex;
  justify-content: center;
  .item {
    min-width: 70px;
    padding: 0 7px;
    height: 24px;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding-top: 1px;
  }
  .not-started {
    color: #238fff;
    background: #ebf5ff;
    border: 1px solid #b5daff;
  }
  .success {
    width: 72px;
    color: #35bf3f;
    background: #f6fcf4;
    border: 1px solid #abeaae;
  }
  .processing {
    color: #ff8900;
    background: #fff4e8;
    border: 1px solid #ffd4a5;
  }
  .ended {
    color: #e3461f;
    background: #fff5f2;
    border: 1px solid #ffc1b2;
  }
}
.select-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .ivu-btn {
    margin-left: auto;
  }
}
</style>